<div class="control has-dropdown" #container>
  <input
    class="input"
    type="text"
    [value]="getDisplayValue()"
    [placeholder]="placeholder"
    readonly
    [disabled]="disabled"
    (focus)="showPicker($event)">
    @if (isVisible) {
      <div class="dropdown-overlay" (click)="isVisible = false"></div>
      <div class="dropdown-grid" [style.top.px]="dropdownTop" [style.left.px]="dropdownLeft">
        <div class="buttons has-addons is-centered is-multiline" [style.grid-template-columns]="'repeat(' + columns + ', 1fr)'">
          <button
            type="button"
            class="button is-small"
            [class.is-selected]="value === -1"
            (click)="selectOption(-1)">
            {{anyOptionLabel}}
          </button>
          @for (option of options; track option) {
            <button
              type="button"
              class="button is-small"
              [class.is-selected]="value === option.value"
              (click)="selectOption(option.value)">
              {{option.label}}
            </button>
          }
        </div>
      </div>
    }
  </div>